import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Slider from 'react-slick';
import get from 'lodash/get';
import map from 'lodash/map';
import omit from 'lodash/omit';

export const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <span
      className={`${className} fas fa-caret-left`}
      style={{ ...style }}
      onClick={onClick}
      onKeyPress={onClick}
      role="button"
      tabIndex="0"
    />
  );
};

export const Arrow = (props) => {
  return (
    <button
      {...omit(props, ['currentSlide', 'slideCount'])}
      tabIndex="0"
    />
  );
};

PrevArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape(),
  onClick: PropTypes.func,
};

PrevArrow.defaultProps = {
  className: '',
  style: {},
  onClick: () => { },
};

export const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <span
      className={`${className} fas fa-caret-right`}
      style={{ ...style }}
      onClick={onClick}
      onKeyPress={onClick}
      role="button"
      tabIndex="0"
    />
  );
};

NextArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape(),
  onClick: PropTypes.func,
};

NextArrow.defaultProps = {
  className: '',
  style: {},
  onClick: () => { },
};

export default class extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    itemList: PropTypes.arrayOf(PropTypes.shape()),
    uiRenderer: PropTypes.func,
    settings: PropTypes.shape(),
  };

  static defaultProps = {
    className: 'default-slider',
    itemList: [],
    uiRenderer: () => null,
    settings: {},
  };
  shouldComponentUpdate(nextProps, nextState) {
    return !_.isEqual(nextProps.itemList, this.props.itemList);
  }

  render() {
    const { itemList, uiRenderer, settings, className } = this.props;
    const defaultSettings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: get(settings, 'slidesToShow') === 1,
      cssEase: 'linear',
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
      autoplay: true,
      autoplaySpeed: 5000,
      // gutter: 0,
      // variableWidth: true,
      ...settings,
    };
    const { gutter } = defaultSettings;
    return (
      <Slider className={className} {...defaultSettings}>
        {map(itemList, (item, key) => {
          return uiRenderer(item, key);
        })}
      </Slider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Slider.js